import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fe15612"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "call" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-container" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "logo" })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_login = _resolveComponent("login")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleLogin && _ctx.toggleLogin(...args))),
      class: "call__button"
    }, "Login"),
    _createElementVNode("div", {
      class: "trigger-area",
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleLogin && _ctx.toggleLogin(...args)))
    }, [
      _createVNode(_component_login, {
        onRecoverPassword: _cache[1] || (_cache[1] = 
          () => {
            _ctx.toggleLogin();
            _ctx.$router.push({
              name: 'home',
              params: { resetPass: 'reset-password', resetBy: 'identity' }
            });
          }
        ),
        onToggleLogin: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleLogin())),
        onToggleRegisterModal: _cache[3] || (_cache[3] = 
          () => {
            _ctx.toggleLogin();
            _ctx.toggleRegisterModal();
          }
        ),
        class: "call__login"
      })
    ])
  ]))
}